import React from 'react'
import "./project.css"
import youtube from "../../image/Project/youtube.png"
import cric from "../../image/Project/Cric.png"
import netmeds from "../../image/Project/netmeds.png"
import rodan from "../../image/Project/rodan.png"
import zappos from "../../image/Project/zappos.png"

const projectsData = [
    {
        id: 2,
        title: 'Zappos Clone',
        img: zappos,
        desc: 'Zappos.com is an American online shoe and clothing retailer which deals in all type of clothes and it is acquired by amazon',
        worked: 'A collaborative project, built in 10 days by a team of 5 developers.',
        githubLink: 'https://github.com/Royanosh/zappos-backend',
        deployedLink: 'https://zappos-official.netlify.app',
        tags: ['HTML', 'CSS', 'Javascript', 'React', 'Chakra UI', "MongoDB", "ExpressJS", "NodeJS"]
    },
    {
        id: 3,
        title: 'Youtube Clone',
        img: youtube,
        desc: 'YouTube is an American online video sharing and social media platform.It is the most famous video sharing platform in the world.',
        worked: 'A solo project, built in 2 days.',
        githubLink: 'https://github.com/Gulshan7777/Youtube',
        deployedLink: 'https://youtube-tailwindcss.netlify.app',
        tags: ['HTML', 'CSS', 'Javascript', 'React', 'Tailwind CSS']
    },
    {
        id: 1,
        title: 'Netmeds Clone',
        img: netmeds,
        desc: 'Netmeds is the leading pharmaceutical business in india. It is a pharmaceutical website which offers medicines at a very cheaper price and it also provide online doctor consultation',
        worked: 'A collaborative project, built in 10 days by a team of 4 developers.',
        githubLink: 'https://github.com/nidhishpareek/NetMeds-Clone',
        deployedLink: 'https://teamnetlifyclone.netlify.app',
        tags: ['HTML', 'CSS', 'Javascript', 'React', 'Redux', 'Chakra UI']
    },
    {
        id: 5,
        title: 'Rodan & Fields Clone',
        img: rodan,
        desc: 'Rodan & Fields, LLC, known as Rodan + Fields or R+F, is an American multi-level marketing company specializing in skincare products.',
        worked: 'A collaborative project, built in 7 days by a team of 4 developers.',
        githubLink: 'https://github.com/itsvikasdwivedi/Team-Rodan',
        deployedLink: 'https://rodan-clone.netlify.app',
        tags: ['HTML', 'CSS', 'Javascript', 'Bootstrap', "JSON Server"]
    },
    {
        id: 4,
        title: 'CricBuzz Clone',
        img: cric,
        desc: 'Cricbuzz is a very popular sports website which mainly focuses on cricket. It helps individual to catch the live match scores, scorecard, schedules of international and domestic matches along with latest news and videos.',
        worked: 'A collaborative project, built in 5 days by a team of 4 developers.',
        githubLink: 'https://github.com/nidhishpareek/CrickBuzz-Clone',
        deployedLink: 'https://heroic-puffpuff-cbebb9.netlify.app/',
        tags: ['HTML', 'CSS', 'Javascript']
    }
]
const Projects = () => {
    return (
        <div className='project'>
            <div className="heading">
                <p>My Latest Projects</p>
                <p>Below are the Projects listed which are made with the collaborating spirit of my friends and me.</p>
            </div>
            <div className="projectList">
                {projectsData.map(item => {
                    return <div key={item.title}>
                        <div className="Projectphoto">
                            <div onClick={() => {
                                window.open(`${item.deployedLink}`)
                            }}>
                                <img src={item.img ? item.img : netmeds} className="ProjectAni" alt="" />
                                <div className='ribbon'>Scroll to view</div>
                            </div>
                        </div>
                        <div className="Projectdesc">
                            <h2 style={{ cursor: "pointer" }} onClick={() => {
                                window.open(`${item.deployedLink}`)
                            }}>{item.title}</h2>
                            <span>{item.desc}<br />{item.worked}</span>
                            <p>{item.tags && item.tags.map(el => <button key={el} className='techIcon'><span>{el}</span></button>)}</p>
                            <button className='vBtn' onClick={() => {
                                window.open(`${item.githubLink}`)
                            }}>Github</button> <button className='vBtn' onClick={() => {
                                window.open(`${item.deployedLink}`)
                            }}>Live View</button>

                        </div>
                    </div>
                })}

            </div>
        </div>
    )
}

export default Projects